/**
 * Подписи логического значения атрибута.
 */
export type BooleanLabels = {
  yes: string;
  no: string;
};

// Логическое значение читается словом, а не `true`/`false`
const formatScalar = (value: unknown, labels: BooleanLabels): string => {
  if (typeof value === 'boolean') {
    return value ? labels.yes : labels.no;
  }
  return String(value);
};

/**
 * Значение атрибута сущности строкой для показа в карточке. Список разворачивается
 * перечислением, структура — своим содержимым: схема значения задаётся типом атрибута,
 * поэтому разбирать её здесь нечем.
 */
export const formatKmAttrValue = (value: unknown, labels: BooleanLabels): string => {
  if (Array.isArray(value)) {
    return value.map((item) => formatScalar(item, labels)).join(', ');
  }
  if (value !== null && typeof value === 'object') {
    return JSON.stringify(value);
  }
  return formatScalar(value, labels);
};
